/**
 * WCAG Accessibility Fixes
 * ========================
 * This file contains JavaScript fixes for WCAG compliance issues
 * that cannot be resolved through template or CSS changes.
 * All future JS-based WCAG fixes should be added to this file.
 */

/* ==========================================================================
   Fix: Owl Carousel Dot Buttons — WCAG 4.1.2 (Name, Role, Value)
   GemPages Owl Carousel dots render as empty <button> elements with no
   accessible name. This adds aria-label to each dot button.
   ========================================================================== */
(function () {
  function labelOwlDots() {
    document.querySelectorAll('.owl-dots').forEach(function (dotsContainer) {
      dotsContainer.querySelectorAll('.owl-dot').forEach(function (dot, index) {
        var slideNum = index + 1;
        if (dot.classList.contains('active')) {
          dot.setAttribute('aria-label', 'Slide ' + slideNum + ' (current)');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.setAttribute('aria-label', 'Go to slide ' + slideNum);
          dot.removeAttribute('aria-current');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelOwlDots);
  } else {
    labelOwlDots();
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldLabel = false;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (
        mutation.type === 'childList' ||
        (mutation.type === 'attributes' && mutation.attributeName === 'class')
      ) {
        shouldLabel = true;
        break;
      }
    }
    if (shouldLabel) labelOwlDots();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
})();

/* ==========================================================================
   Fix: "More payment options" Link — Keyboard Accessibility
   Shopify's dynamic payment button injects an <a> element without href,
   making it not keyboard focusable. This adds tabindex="0".
   ========================================================================== */
(function () {
  function fixMorePaymentOptions() {
    var link = document.querySelector(
      'a.shopify-payment-button__more-options:not([tabindex])'
    );
    if (link) {
      link.setAttribute('tabindex', '0');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMorePaymentOptions);
  } else {
    fixMorePaymentOptions();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        fixMorePaymentOptions();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: Empty Headings — WCAG 1.3.1 / 2.4.6
   GemPages generates empty heading elements (h1–h6) that contain only
   formatting tags (<font>, <span>, <strong>, <br>) with no visible text.
   This hides them from the accessibility tree with aria-hidden="true".
   ========================================================================== */
(function () {
  function hideEmptyHeadings() {
    var headings = document.querySelectorAll(
      'h1, h2, h3, h4, h5, h6'
    );
    headings.forEach(function (heading) {
      // Skip headings already processed or intentionally hidden
      if (heading.hasAttribute('aria-hidden')) return;
      // Skip headings with the visually-hidden class (used by theme for SR-only text)
      if (heading.classList.contains('visually-hidden')) return;

      // Check if heading has no meaningful text content
      var text = heading.textContent.replace(/\s/g, '');
      if (text.length === 0) {
        // Don't hide headings that contain images or focusable elements
        if (heading.querySelector('img, a, button, input, svg')) return;
        heading.setAttribute('aria-hidden', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyHeadings);
  } else {
    hideEmptyHeadings();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        hideEmptyHeadings();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: Untitled iframes/frames — WCAG 4.1.2 / 2.4.1
   iframes and frames without a title attribute cause VoiceOver (macOS) to
   read a meaningless frame reference. This adds a descriptive title based
   on the iframe src URL.
   ========================================================================== */
(function () {
  var titleMap = [
    { pattern: /youtube\.com|youtu\.be/, title: 'YouTube video' },
    { pattern: /vimeo\.com/, title: 'Vimeo video' },
    { pattern: /klaviyo/, title: 'Email signup form' },
    { pattern: /instagram\.com/, title: 'Instagram embed' },
    { pattern: /facebook\.com|fb\.com/, title: 'Facebook embed' },
    { pattern: /twitter\.com|x\.com/, title: 'Twitter embed' },
    { pattern: /tiktok\.com/, title: 'TikTok embed' },
    { pattern: /pinterest\.com/, title: 'Pinterest embed' },
    { pattern: /google\.com\/maps/, title: 'Google Maps' },
    { pattern: /loopwork|loop-returns/, title: 'Returns and exchanges' },
  ];

  function getTitleFromSrc(src) {
    if (!src) return 'Embedded content';
    for (var i = 0; i < titleMap.length; i++) {
      if (titleMap[i].pattern.test(src)) return titleMap[i].title;
    }
    return 'Embedded content';
  }

  function labelUntitledFrames() {
    var frames = document.querySelectorAll('iframe:not([title]), frame:not([title])');
    frames.forEach(function (frame) {
      frame.setAttribute('title', getTitleFromSrc(frame.getAttribute('src')));
    });
    // Also fix frames with empty title attribute
    var emptyTitles = document.querySelectorAll('iframe[title=""], frame[title=""]');
    emptyTitles.forEach(function (frame) {
      frame.setAttribute('title', getTitleFromSrc(frame.getAttribute('src')));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelUntitledFrames);
  } else {
    labelUntitledFrames();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        labelUntitledFrames();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: Empty Links — WCAG 4.1.2 / 2.4.4 (Link Purpose)
   Empty <a> elements (no text, no aria-label, no img with alt) get no
   accessible name, so screen readers read the raw URL. This adds an
   aria-label derived from the href.
   ========================================================================== */
(function () {
  function isLinkEmpty(link) {
    // Has aria-label or aria-labelledby already
    if (link.getAttribute('aria-label') || link.getAttribute('aria-labelledby')) return false;
    // Has an img with alt text inside
    var imgs = link.querySelectorAll('img[alt]:not([alt=""])');
    if (imgs.length > 0) return false;
    // Has visible text content
    var text = link.textContent.replace(/\s/g, '');
    if (text.length > 0) return false;
    return true;
  }

  function getContextLabel(link) {
    // Try the closest heading
    var container = link.closest('section, article, div, li, .gf_row, .element-wrap');
    if (container) {
      var heading = container.querySelector('h1, h2, h3, h4, h5, h6');
      if (heading && !link.contains(heading)) {
        var hText = heading.textContent.trim();
        if (hText.length > 0) return hText;
      }
      // Try nearby paragraph or span text
      var textEl = container.querySelector('p, span');
      if (textEl && !link.contains(textEl)) {
        var pText = textEl.textContent.trim();
        if (pText.length > 0 && pText.length < 80) return pText;
      }
    }
    return '';
  }

  function getLabelFromHref(href, link) {
    if (!href) return getContextLabel(link) || 'Interactive element';
    // mailto links
    var mailto = href.match(/^mailto:(.+)/i);
    if (mailto) return 'Send email to ' + mailto[1].split('?')[0];
    // tel links
    var tel = href.match(/^tel:(.+)/i);
    if (tel) return 'Call ' + tel[1];
    // Hash-only or javascript links — use surrounding context
    if (href === '#' || href.startsWith('javascript:')) {
      return getContextLabel(link) || 'Interactive element';
    }
    // Try to extract a readable name from the URL path
    try {
      var url = new URL(href, window.location.origin);
      var hostname = url.hostname.replace('www.', '');
      // Known social / external domains
      var domains = {
        'facebook.com': 'Facebook', 'instagram.com': 'Instagram',
        'twitter.com': 'Twitter', 'x.com': 'Twitter',
        'youtube.com': 'YouTube', 'tiktok.com': 'TikTok',
        'pinterest.com': 'Pinterest', 'snapchat.com': 'Snapchat',
        'tumblr.com': 'Tumblr', 'vimeo.com': 'Vimeo',
      };
      if (domains[hostname]) return domains[hostname];
      // Internal links — use the last path segment
      var path = url.pathname.replace(/\/$/, '');
      if (path && path !== '/') {
        var segment = path.split('/').pop().replace(/[-_]/g, ' ');
        return segment.charAt(0).toUpperCase() + segment.slice(1);
      }
      return hostname;
    } catch (e) {
      return getContextLabel(link) || 'Interactive element';
    }
  }

  var nonDescriptiveLabels = /^(link|click here|click|here|read more|more|learn more|details|info|button)$/i;

  function labelEmptyLinks() {
    var links = document.querySelectorAll('a[href]');
    links.forEach(function (link) {
      if (isLinkEmpty(link)) {
        link.setAttribute('aria-label', getLabelFromHref(link.getAttribute('href'), link));
      }
      // Also fix links with non-descriptive aria-label
      var currentLabel = link.getAttribute('aria-label');
      if (currentLabel && nonDescriptiveLabels.test(currentLabel.trim())) {
        var betterLabel = getLabelFromHref(link.getAttribute('href'), link);
        if (!nonDescriptiveLabels.test(betterLabel.trim())) {
          link.setAttribute('aria-label', betterLabel);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelEmptyLinks);
  } else {
    labelEmptyLinks();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        labelEmptyLinks();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: aria-hidden with focusable content — WCAG 4.1.2
   Elements with aria-hidden="true" that contain focusable children (links,
   buttons, inputs, etc.) create silent focus traps — the user tabs into
   them but hears nothing. This removes those children from the tab order
   by setting tabindex="-1".
   ========================================================================== */
(function () {
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  function fixAriaHiddenFocusable() {
    var hiddenEls = document.querySelectorAll('[aria-hidden="true"]');
    hiddenEls.forEach(function (hidden) {
      // Also fix the element itself if it is focusable
      if (hidden.matches(focusableSelector)) {
        hidden.setAttribute('tabindex', '-1');
      }
      // Fix focusable descendants
      var focusable = hidden.querySelectorAll(focusableSelector);
      focusable.forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAriaHiddenFocusable);
  } else {
    fixAriaHiddenFocusable();
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldFix = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length ||
          (mutations[i].type === 'attributes' && mutations[i].attributeName === 'aria-hidden')) {
        shouldFix = true;
        break;
      }
    }
    if (shouldFix) fixAriaHiddenFocusable();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });
})();

/* ==========================================================================
   Fix: Duplicate Link Text — WCAG 2.4.4 (Link Purpose in Context)
   When multiple links share the same visible text (e.g. "Shop now") but
   point to different URLs, screen reader users cannot distinguish them.
   This adds aria-label combining the link text with a nearby heading for
   context (e.g. "Shop now - Silk Dress").
   ========================================================================== */
(function () {
  function getContextHeading(el) {
    // Walk up to find the nearest card / section / article container
    var container = el.closest(
      '.card, .product-card, .card-wrapper, article, .collection-card, ' +
      '.gf_row, .element-wrap, [data-product-card], .grid__item, ' +
      '.card--standard, .card--card'
    );
    if (container) {
      var heading = container.querySelector('h1, h2, h3, h4, h5, h6, .card__heading, .card__text');
      if (heading && heading !== el && !el.contains(heading)) {
        var text = heading.textContent.trim();
        if (text.length > 0) return text;
      }
    }
    // Check for navigation context (header menus, mega menus)
    var navItem = el.closest('li, details');
    if (navItem) {
      // Look for a parent menu item (e.g., mega menu parent link)
      var parentDetails = navItem.closest('details');
      if (parentDetails) {
        var summary = parentDetails.querySelector('summary');
        if (summary && !summary.contains(el)) {
          var summaryText = summary.textContent.trim();
          if (summaryText.length > 0) return summaryText;
        }
      }
    }
    var nav = el.closest('nav');
    if (nav) {
      var navLabel = nav.getAttribute('aria-label');
      if (navLabel) return navLabel;
    }
    // Try the link's own href as fallback context
    var href = el.getAttribute('href');
    if (href && href !== '#') {
      try {
        var url = new URL(href, window.location.origin);
        var path = url.pathname.replace(/\/$/, '');
        if (path && path !== '/') {
          var segment = path.split('/').pop().replace(/[-_]/g, ' ');
          return segment.charAt(0).toUpperCase() + segment.slice(1);
        }
      } catch (e) { /* ignore */ }
    }
    return '';
  }

  function getAccessibleName(link) {
    // If aria-labelledby exists, resolve the referenced text
    var labelledby = link.getAttribute('aria-labelledby');
    if (labelledby) {
      var ids = labelledby.split(/\s+/);
      var parts = [];
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) parts.push(el.textContent.trim());
      });
      if (parts.length > 0) return parts.join(' ').trim().toLowerCase();
    }
    return link.textContent.trim().toLowerCase();
  }

  function getProductPrice(link) {
    var card = link.closest('.card, .card-wrapper, .product-card, [data-product-card]');
    if (card) {
      var priceEl = card.querySelector('.price-item--regular, .price-item--sale, .price .money');
      if (priceEl) return priceEl.textContent.trim();
    }
    return '';
  }

  function fixDuplicateLinkText() {
    var links = document.querySelectorAll('a[href]');
    // Group links by their accessible name
    var textGroups = {};
    links.forEach(function (link) {
      // Skip links that already have aria-label
      if (link.getAttribute('aria-label')) return;
      var text = getAccessibleName(link);
      if (!text || text.length === 0) return;
      if (!textGroups[text]) textGroups[text] = [];
      textGroups[text].push(link);
    });

    // For each group with duplicate text, check if they go to different URLs
    Object.keys(textGroups).forEach(function (text) {
      var group = textGroups[text];
      if (group.length < 2) return;

      // Check if there are different destinations
      var hrefs = {};
      group.forEach(function (link) {
        hrefs[link.getAttribute('href')] = true;
      });
      if (Object.keys(hrefs).length < 2) return;

      // Different destinations — add context via aria-label
      group.forEach(function (link) {
        var context = getContextHeading(link);
        var price = getProductPrice(link);
        var label = link.textContent.trim();
        if (price) {
          label += ' - ' + price;
        }
        if (context) {
          label += ' - ' + context;
        }
        // Always append URL path as final unique differentiator
        var href = link.getAttribute('href');
        if (href) {
          try {
            var url = new URL(href, window.location.origin);
            var slug = url.pathname.split('/').pop().replace(/[-_]/g, ' ');
            if (slug) label += ' - ' + slug;
          } catch (e) { /* ignore */ }
        }
        link.setAttribute('aria-label', label);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDuplicateLinkText);
  } else {
    fixDuplicateLinkText();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        fixDuplicateLinkText();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: Empty Accordion Toggle Buttons — WCAG 4.1.2
   GemPages accordion buttons (button.wrapp-icon) contain only an icon span
   with no text or aria-label. This derives a label from the sibling
   accordion heading text (e.g. "Toggle UNITED STATES/CANADA").
   ========================================================================== */
(function () {
  function labelAccordionButtons() {
    var buttons = document.querySelectorAll('button.wrapp-icon:not([aria-label])');
    buttons.forEach(function (btn) {
      // Find the parent accordion control container
      var control = btn.closest('[data-control]');
      if (control) {
        // Look for the heading text block inside the same control
        var textEl = control.querySelector('.elm.text-edit');
        if (textEl) {
          var text = textEl.textContent.trim();
          if (text.length > 0) {
            btn.setAttribute('aria-label', 'Toggle ' + text);
            return;
          }
        }
      }
      // Fallback
      btn.setAttribute('aria-label', 'Toggle section');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelAccordionButtons);
  } else {
    labelAccordionButtons();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        labelAccordionButtons();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: Form Controls Without Accessible Names — WCAG 4.1.2
   Inputs, selects, and textareas without a linked label, aria-label,
   aria-labelledby, or title are invisible to screen readers. This adds
   an aria-label derived from name, type, or placeholder attributes.
   ========================================================================== */
(function () {
  function hasAccessibleName(el) {
    // Has aria-label or aria-labelledby
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return true;
    // Has title
    if (el.getAttribute('title')) return true;
    // Has a linked <label> via id
    var id = el.getAttribute('id');
    if (id && document.querySelector('label[for="' + id + '"]')) return true;
    // Is wrapped in a <label>
    if (el.closest('label')) return true;
    return false;
  }

  function getLabelFromAttributes(el) {
    // Try placeholder
    var placeholder = el.getAttribute('placeholder');
    if (placeholder && placeholder.trim().length > 0) return placeholder.trim();
    // Try name attribute — humanize it
    var name = el.getAttribute('name');
    if (name) {
      // Clean up common Shopify/form name patterns
      var clean = name
        .replace(/\[\]/g, '')
        .replace(/\[.*\]/g, '')
        .replace(/^(checkout|cart|contact|customer)\[?/i, '')
        .replace(/[-_]/g, ' ')
        .trim();
      if (clean.length > 0) {
        return clean.charAt(0).toUpperCase() + clean.slice(1);
      }
    }
    // Try type
    var type = (el.getAttribute('type') || 'text').toLowerCase();
    var typeLabels = {
      'search': 'Search',
      'email': 'Email',
      'tel': 'Phone number',
      'url': 'URL',
      'password': 'Password',
      'number': 'Number',
      'file': 'File upload',
      'color': 'Color picker',
      'date': 'Date',
      'time': 'Time',
      'range': 'Range',
    };
    if (typeLabels[type]) return typeLabels[type];
    // Fallback
    return 'Input field';
  }

  function labelUnnamedControls() {
    var controls = document.querySelectorAll(
      'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([type="image"]), ' +
      'select, textarea'
    );
    controls.forEach(function (control) {
      if (!hasAccessibleName(control)) {
        control.setAttribute('aria-label', getLabelFromAttributes(control));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelUnnamedControls);
  } else {
    labelUnnamedControls();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        labelUnnamedControls();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ==========================================================================
   Fix: Images Without Alt Text — WCAG 1.1.1 (Non-text Content)
   Images without alt attributes cause screen readers to read the filename
   or ignore the image entirely. Decorative images get alt="" and
   meaningful images get alt text derived from the filename.
   ========================================================================== */
(function () {
  // Patterns indicating decorative/background images
  var decorativePatterns = /(^|[\s_-])(videobg|bg|background|spacer|decorative|placeholder|blank|pixel|separator|divider)([\s_-]|$)/i;

  function isDecorative(img) {
    var cls = img.className || '';
    var src = img.getAttribute('src') || '';
    var role = img.getAttribute('role') || '';
    // Explicitly marked as decorative
    if (role === 'presentation' || role === 'none') return true;
    // Class or src suggests decorative
    if (decorativePatterns.test(cls) || decorativePatterns.test(src)) return true;
    // Tiny images (tracking pixels, spacers)
    if (img.naturalWidth > 0 && img.naturalWidth < 5) return true;
    if (img.naturalHeight > 0 && img.naturalHeight < 5) return true;
    return false;
  }

  function getAltFromSrc(src) {
    if (!src) return 'Image';
    try {
      var url = new URL(src, window.location.origin);
      var filename = url.pathname.split('/').pop();
      // Remove file extension
      filename = filename.replace(/\.[^.]+$/, '');
      // Remove Shopify CDN size suffixes
      filename = filename.replace(/_\d+x\d*/, '').replace(/_\d+x/, '');
      // Humanize: replace dashes/underscores, trim
      filename = filename.replace(/[-_]+/g, ' ').trim();
      if (filename.length > 0 && filename.length < 120) {
        return filename.charAt(0).toUpperCase() + filename.slice(1);
      }
    } catch (e) { /* ignore */ }
    return 'Image';
  }

  function fixMissingAlt() {
    var images = document.querySelectorAll('img:not([alt])');
    images.forEach(function (img) {
      if (isDecorative(img)) {
        img.setAttribute('alt', '');
      } else {
        img.setAttribute('alt', getAltFromSrc(img.getAttribute('src')));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMissingAlt);
  } else {
    fixMissingAlt();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        fixMissingAlt();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
